import { EmailTabs } from '@/constants';
import { useDispatch, useSelector } from 'react-redux';
import emailSlice, { emailTabSelector } from '@/redux/features/email.slice';
import { emailTabsConfig } from './config';
import { BlockStack, Tabs } from '@shopify/polaris';
import { Receiver } from '@/constants/enum';
import CustomWorkflows from './components/CustomWorkflows';

const EmailNotifications = () => {
  const dispatch = useDispatch();
  const selectedTab = useSelector(emailTabSelector);
  const tabIndex = Math.max(
    0,
    Object.values(EmailTabs).findIndex((tab) => tab === selectedTab),
  );

  const handleChangeTab = (tab: number) => {
    const emailTab = Object.values(EmailTabs)[tab];

    dispatch(emailSlice.actions.handleChangeEmailTab(emailTab));
    dispatch(
      emailSlice.actions.handleChangeEmailTemplatesTab(emailTab === EmailTabs.ToCustomer ? Receiver.Customer : Receiver.Merchant),
    );
  };

  return (
    <Tabs tabs={emailTabsConfig} selected={tabIndex} onSelect={handleChangeTab} fitted>
      <BlockStack gap="1600">
        <div style={{ paddingTop: 32 }}>{emailTabsConfig[tabIndex].component}</div>
        <CustomWorkflows />
      </BlockStack>
    </Tabs>
  );
};

export default EmailNotifications;
